export const storageKey = {
  TOKEN: 'token',
  DOCTORNAME: 'doctorname',
  CREATE_SEQUENCE_SOURCE: 'createSequenceSource',
  CREATE_TASK_SOURCE: 'createTaskSource',
  ENROLL_FORM_SOURCE: 'enrollFormSource',
  REFERRAL_ROUTE: 'referralRouter',
  TENANT_HASH: 'tenantHash',
  GLOBAL_SEARCH: 'globalSearch',
  IsPermanentOpen: 'isPermanentOpen',
  CLINIC_ID: 'clinicId'
};

const storage = {
  set: (key, data) => {
    return sessionStorage.setItem(storageKey[key], data);
  },
  get: (key) => {
    return sessionStorage.getItem(storageKey[key]);
  },
  del: (key) => {
    return sessionStorage.removeItem(storageKey[key]);
  },
};
export default storage;

export const getBaseURL = () => {
  // return `https://${localStorage.getItem(mainConnector)}` || 'https://tr-testing.succede.com';
  return `https://staging-api.superreach.com`;
};
